import { apiServiceProxy } from '../api-proxy';

class MessagingService {
  public async getChats() {
    return apiServiceProxy.get('/chat?per_page=200&page=1');
  }

  public async getMessagesChat(id: number) {
    return apiServiceProxy.get(`/chat/${id}`);
  }

  public async sendMessageChat(id: number, content: string, sendEmail: boolean) {
    return apiServiceProxy.post(`/chat/${id}`, { content, send_email: sendEmail });
  }

  public async listProducts() {
    return apiServiceProxy.get('/chat/products');
  }

  public async listAffiliates(products: number[]) {
    return apiServiceProxy.get('/chat/products/affiliates', { params: { products } });
  }

  public async sendMessageBroadcast(content: string, customers: any, sendEmail: boolean) {
    return apiServiceProxy.post('/chat/broadcast', { content, customers, send_email: sendEmail });
  }
}

export const messagingService = new MessagingService();
